import { Attribution } from 'types'

import { buildAdsTableFilterSql } from './adsTableFilters'

interface Params {
  endDate: string
  startDate: string
  id: string
  attr: Attribution
  groupBy: 'campaign' | 'ad' | 'ad_set'
  filterCampaignId?: string | null
  filterAdSetId?: string | null
}

export const getAdsChannelsSourcesSum = ({
  endDate,
  startDate,
  id,
  attr,
  groupBy,
  filterCampaignId,
  filterAdSetId,
}: Params) => {
  const attrTableName =
    attr === 'first' || attr === 'last' ? attr : `${attr}_source`
  const attrPrefix = attr === 'first' || attr === 'last' ? `${attr}_` : ''

  let fetchingProps
  if (groupBy === 'campaign') {
    fetchingProps = `${attrPrefix}ad_campaign.ad_campaign_id`
  } else if (groupBy === 'ad') {
    fetchingProps = `${attrPrefix}ad_source.source_id`
  } else if (groupBy === 'ad_set') {
    fetchingProps = `${attrPrefix}ad_set.ad_set_id`
  }

  // For the "ad" groupBy count query, skip the ad_set filter: first_ad_set isn't joined
  // (only first_ad_source is), and adding it would create a non-aggregated column in the
  // outer SELECT. Use campaign filter via first_ad_source.ad_campaign_ext_id instead.
  // We pass groupBy as 'ad_set' so buildAdsTableFilterSql emits the campaign filter,
  // but null for filterAdSetId so no ad_set filter is added.
  const filterSql =
    groupBy === 'ad'
      ? buildAdsTableFilterSql(attr, 'ad_set', filterCampaignId, null)
      : buildAdsTableFilterSql(attr, groupBy, filterCampaignId, filterAdSetId)

  return `SELECT COUNT(DISTINCT ${fetchingProps}), SUM(${attrTableName}.ad_impressions) FROM source WHERE stats.event_date <= '${endDate}' AND stats.event_date >= '${startDate}' AND stats.channel_id = '${id}'${filterSql}`
}
